import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	manualRenderVariantDropdownOptionLabel: {
		id: 'company-hub.company-hub-common.config-panel.render-variant.dropdown.option.label.manual',
		defaultMessage: 'Manual',
		description:
			'Label for manual card variant that is displayed in the config panel card variant switcher button allowing user to switch between manual and dynamic card variants',
	},
	dynamicRenderVariantDropdownOptionLabel: {
		id: 'company-hub.company-hub-common.config-panel.render-variant.dropdown.option.label.dynamic',
		defaultMessage: 'Dynamic',
		description:
			'Label for dynamic card variant that is displayed in the config panel card variant switcher button allowing user to switch between manual and dynamic card variants',
	},
	dropdownLabel: {
		id: 'company-hub.company-hub-common.config-panel.render-variant.dropdown.label',
		defaultMessage: 'Card type',
		description: 'Label for the card type dropdown in the config panel',
	},
});
